import {NameSchema, Roles} from "@/utils/constants/common.constants.ts";
import {Push} from "notivue";
import {z} from "zod";

export interface IAuthRequest {
  email: string,
  password: string
}

export interface ILoginByPhoneNumberRequest {
  phoneNumber: string,
  password: string
}

export interface IRegisterRequest extends IAuthRequest {
  name: string
}

export interface ICompletePhoneNumberRegistrationDetails extends Pick<ApiPayload, "completePhoneNumberRegistrationDetailsToken"> {
  name: string,
  classLevel: `${ClassLevel}`,
  password: string,
}

export interface ICompleteProfileForGoogleAccount extends IUser {
}

export interface ILoginOrRegisterByPhoneNumber {
  phoneNumber: string
}

export interface IValidateOTPRequest {
  otp: string
}

export interface IValidatePhoneNumberOTPRequest extends IValidateOTPRequest {
  phoneNumber: string
}

export interface IResetPasswordRequest {
  token: string,
  password: string
}


export interface IGetResult {
  messageType?: keyof Push,
  success?: boolean,
  message?: string,
  title?: string,
  data?: ApiPayload,
  redirectUrl?: string
}

export interface IRegisterResponse {
  email: string
}

export interface IUser extends TimestampsConfig {
  _id: string,
  name: string;
  nickName?: string;
  code: string;
  email?: string;
  lastLogin: Date;
  status?: IAttendance['status'];
  _changedCells?: Record<string, boolean>;
  createdBy: IUser;
  forceLogoutAt?: Date | undefined;
  role: Roles;
  provider?: "local" | "google";
  avatar?: string;
  password?: string;
  groups?: {
    math?: IGroup | null,
    physics?: IGroup | null
  },
  isProfileCompleted: boolean;
  isVerified: boolean;

  // googleId?: string;
  // phoneNumber: string,
  classLevel?: ClassLevel | null,
  // fatherPhoneNumber?: string,


}

export interface ITokenResponse {
  token: string
}

export interface IFetchCurrentUserResponse {
  user: Omit<IUser, "password">
}

export interface IChangePasswordRequest {
  oldPassword: string,
  newPassword: string
}

export interface IDetectPhoneNumberRequest extends Pick<ApiPayload, "completePhoneNumberRegistrationDetailsToken"> {
  phoneNumber: string
}

export interface ICloudinarySignatureResponse {
  timestamp: string,
  signature: string,
  apiKey: string,
  cloudName: string
}

export interface IUpdateProfileRequest extends IUser {

}

export interface ILoginByCodeAndPassword extends Pick<IUser, "code" | "password"> {
}

export interface IExam extends TimestampsConfig {
  _id:string,
  subject: Subject | null ,
  grade: number | null,
  name: string,
  maxGrade: number | null,
  student: IUser | null ,
  classLevel: ClassLevel
}

export enum PaymentStatus {
  PAID = "paid",
  REFUNDED = "refunded",
  CANCELED = "canceled"
}

export interface IPayment extends TimestampsConfig {
  _id: string,
  student: IUser,
  amount: number,
  month: any,
  _changedCells: Record<string, boolean>,
  year: number,
  subject: `${Subject}`,
  addedBy: IUser,
  status: `${PaymentStatus}`,
  note?: string
}
export interface ApiPayload {
  phoneNumber?: string,
  user?: IUser,
  completePhoneNumberRegistrationDetailsToken?: string,
  resetPasswordToken?: string,
  function?: "initUser",
  message?: string,
  students?: IUser[],
  studentGrades?: IExam[] | null,
  timestamp?: number,
  signature?: string,
  apiKey?: string,
  cloudName?: string,
  lessons?: ILesson[]
  lesson?: ILesson,
  lessonsForStudent?: Omit<ILesson, "attendance">[] | null,
  grades?: IExam[],
  studentPayments?: IPayment[] | null
  payments?: IPayment[] | null,
  data?: any,
  forceUserToLogoutOut?: boolean
}

export interface TimestampsConfig {
  createdAt: Date | string;
  updatedAt: Date | string;
}

export interface ILesson extends TimestampsConfig {
  _id: string,
  title?: string,
  subject: Subject | null,
  classLevel: ClassLevel | null,
  attendance: IAttendance[],
  group: IGroup | null
}

export enum AttendanceStatus {
  Present = "حاضر",
  Absent = "غايب",
  Late = "متأخر",
  Excused = "معذور",
  Initial = "لا يوجد",
  WrongGroup = "حاضر في مجموعة أخرى",
}

export interface IAttendance extends TimestampsConfig{
  _id: string,
  student: IUser,
  payments: IPayment[],
  status: AttendanceStatus,
  previousStatus: AttendanceStatus,
  note?: string
}

export interface ViewAllStudentsResponse {

}

export enum ClassLevel {
  FirstSecondary = "الصف الأول الثانوي",
  SecondSecondary = "الصف الثاني الثانوي",
  ThirdSecondary = "الصف الثالث الثانوي"
}

export enum Subject {
  Math = "الرياضيات",
  Physics = "الفيزياء"
}
export interface IRegisterExamGradeRequest {
  studentId: string,
  grade: number,
  maxGrade: number,
  classLevel: `${ClassLevel}`;
  subject: `${Subject}`;
}

export interface ISubmitExamRequest extends IExam{
}

export interface ICreateLessonRequest extends Omit<Omit<ILesson, keyof TimestampsConfig>, "_id" | "attendance"> {
}

export interface ICreatePaymentRequest extends Omit<IPayment, "addedBy"> {
}

export interface ICreateGroupRequest extends IGroup {
}

export interface IAddAttendanceRequest {
  student: Pick<IUser, "_id" | "name" | "groups">,
  status?: `${AttendanceStatus}`
  lessonId: string,
}

export interface IDeleteAttendanceRequest {
  attendanceId:string
  lessonId: string
}

export interface IUpdateStudentRequest extends Partial<IUser> {
  groups: IUser['groups']
}

export interface ICreateStudentRequest extends Pick<IUser, "name" | "classLevel" | "isProfileCompleted" | "groups" | "password"> {
}

export interface IGroup extends TimestampsConfig{
  _id: string,
  name: string,
  subject: Subject,
  maxStudents: number,
  classLevel: ClassLevel
}

export type QueryFilter<T> = {
  filter?: Partial<T>,
  search?: string,
  limit?: number,
  page?: number
}

export const GroupSchema = z.object({
  _id: z.string(),
  name: NameSchema,
  subject: z.nativeEnum(Subject),
  maxStudents: z.number().int().positive(),
  classLevel: z.nativeEnum(ClassLevel),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});